// Lodash
import { get } from 'lodash';
import { BUSINESS_METHOD_CONSTANT, BUSINESS_NGRX_CONSTANTS } from '../../../../constants/ngrx-store/business';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { AuthState, initialState } from './state';

/**
 * This reducer is for store data using actions.
 * For auth data store purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially create ruducer with few actions
 * Date: 15/04/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) added login actions
 * Date: 02/05/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) added logout actions
 */
export function reducer(state = initialState, action: Actions): AuthState {
  switch (action.type) {
    // AUTH COMMON METHOD
    case ActionTypes.AUTH_COMMON: {
      return state;
    }
    // AUTH_COMMON_SUCCESS COMMON METHOD
    case ActionTypes.AUTH_COMMON_SUCCESS: {
      // commonly store and handle all auth modules
      if (action.response && action.response.common && action.response.common.API_METHOD && action.response.common.API_METHOD === 'getUserAndBusiness' && action.response && action.response.data && action.response.data.data && action.response.data.data.user.user_business) {
        // state.user.user_first_name = action.response.data.data.user.user_business.user_business_first_name;
        // state.user.user_last_name = action.response.data.data.user.user_business.user_business_last_name;
        // state.user.user_profile_url = action.response.data.data.user.user_business.user_business_profile_image_url;

        return {
          ...state,
          user: {
            ...state.user,
            ...action.response.data.data.user.global_user,
            ...action.response.data.data.user.user_business,
            user_business: state.user ? {
              ...state.user.user_business,
              ...action.response.data.data.user.user_business,
            } : {
              ...action.response.data.data.user.user_business,
            }
          }
        };
      }
 
      if (action.response && action.response.common && action.response.common.API_METHOD && action.response.common.API_METHOD === 'signUp' &&  action.response.data && action.response.data.data && action.response.data.data.users) {
        return {
          ...state,
          user: action.response.data.data.users[0],
          [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
        };
    }
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }
    // LOGIN METHOD
    case ActionTypes.LOGIN: {
      return state;
    }
    // LOGIN_SUCCESS METHOD
    case ActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        user: action.response.data,
      };
    }

    case ActionTypes.UPDATE_PROFILE_DETAILS_SUCCESS: {
      if (state && state.user && state.user.user_id && action && action.response
        && action.response.data && action.response.data.data && action.response.data.data.employees
        && action.response.data.data.employees.employee_fk_user_id && action.response.data.data.employees.employee_fk_user_id === state.user.user_id) {
        return {
          ...state,
          user: {
            ...state.user,
            ...action.response.data.data.employees,
            user_business_first_name: action.response.data.data.employees.user_first_name,
            user_business_last_name: action.response.data.data.employees.user_last_name,

          },
        };
      } else {
        return state;
      }

    }
    // LOGOUT METHOD
    case ActionTypes.LOGOUT: {
      return state;
    }
    // LOGOUT_SUCCESS METHOD
    case ActionTypes.LOGOUT_SUCCESS: {
      return initialState;
    }

    // LOGOUT_SUCCESS METHOD
    case ActionTypes.CHANGE_BUSINESS_SUCCESS: {
      if (state && state.user && state.user.user_id && action.response && action.response.data && action.response.data.business.user_business) {
        return {
          ...state,
          user: {
            ...state.user,
            ...action.response.data.business.user_business,
          },
        };
      }
      return state;
    }


    // CLEAR_REDUCER METHOD ON LOGOUT
    case ActionTypes.CLEAR_REDUCER: {
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
